import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DataTable, FlexBox, Icon, Page, Text } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';
import { Link } from 'react-router-dom';
import { useMount } from 'react-use';
import { withAutomations } from 'hocs';
import { useAppPathParams } from 'utils/url/useAppPathParams';
export const SettingsAutomationsAuditLogView = withAutomations(({ automations: { item, getItem, getItemAsyncStatus } }) => {
    var _a, _b;
    const { automationId } = useAppPathParams('/settings/automations/flow/:automationId/history');
    useMount(() => {
        getItem(automationId);
    });
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: _jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center" }, { children: [_jsx(Link, Object.assign({ to: "/settings/automations", style: { color: 'inherit' } }, { children: _jsx(Text.Heading, { children: "Automations" }) })), _jsx(Icon, { name: "angle-right" }), item === null || item === void 0 ? void 0 : item.name] })) }), _jsx(Page.Body, { children: _jsx(Page.Section, Object.assign({ title: "Audit log" }, { children: _jsx(DataTable, { columns: [
                            {
                                label: 'Edit',
                                selector: ({ updated_by }) => updated_by,
                                style: {
                                    width: '70%',
                                },
                            },
                            {
                                label: 'Date',
                                selector: ({ updated_at }) => {
                                    const time = moment(updated_at);
                                    const localeData = moment.localeData();
                                    return time.format(`DD MMMM YYYY, ${localeData.longDateFormat('LT')}`);
                                },
                            },
                        ], data: (_a = item === null || item === void 0 ? void 0 : item.updated_by_history) !== null && _a !== void 0 ? _a : [], tableStatusProps: {
                            loading: getItemAsyncStatus === 'loading',
                            loadingFailed: getItemAsyncStatus === 'failed',
                            emptyState: getItemAsyncStatus === 'succeeded' &&
                                ((_b = item === null || item === void 0 ? void 0 : item.updated_by_history) === null || _b === void 0 ? void 0 : _b.length) === 0
                                ? {
                                    title: 'No data available',
                                    description: '',
                                }
                                : undefined,
                        } }) })) })] }));
});
